import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { UserSession } from '@/types/general';

export const fetchUser = createAsyncThunk('user/fetchUser', async () => {
  const res = await fetch('/api/auth/me');
  if (res.status === 401) window.location.href = '/auth/sign-in';
  if (!res.ok) throw new Error('Failed to fetch user');
  return await res.json();
});

interface UserInitialState {
  user: UserSession | null;
  isLoading: boolean;
  error: string | null;
}

const initialState: UserInitialState = {
  user: null,
  isLoading: true,
  error: null,
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    clearUser: (state) => {
      state.user = null;
      state.isLoading = false;
    },
    setUser: (state, action: PayloadAction<UserSession>) => {
      state.user = action.payload;
      state.isLoading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUser.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchUser.fulfilled, (state, action) => {
        state.user = action.payload;
        state.isLoading = false;
      })
      .addCase(fetchUser.rejected, (state) => {
        // state.error = action.error.message
        state.isLoading = false;
      });
  },
});

export const { setUser, clearUser } = userSlice.actions;
